import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast } from "../../../components/toast/Toasts";
import { IBandhaiData } from "../bandhaisettlementformModal";

export const getBandhaiSettlementDetail = createAsyncThunk(
  "KarigarSettlement/KarigarSettlementApi",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/KarigarSettlement/KarigarSettlementApi`,
        formdata,
      );
      return response.data?.Data as IBandhaiData;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai Settlement Data:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const updateBandhaiSettlementDetail = createAsyncThunk(
  "KarigarSettlement/SettlementUpdateByIDs",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/KarigarSettlement/SettlementUpdateByIDs`,
        formdata,
      );
      return response.data?.Data as IBandhaiData;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai Settlement Data:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
